import { memo, useContext, useEffect } from 'react';
import history from '@history';
import { useDispatch, useSelector } from 'react-redux';
import { useRequest } from '@main/hooks';
import { closeNotificationPanel, getNotifications } from '@modules/notifications/store';
import { clickNotification, destroyAllNotifications, destroyNotification, findNotifications } from 'src/app/api/profile';
import { NotificationPanel } from '@modules/notifications/components';
import { NotificationClientContext } from '@modules/notifications/providers/NotificationClientContext';

function RightSideLayout1(props) {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { notifications, panel } = useSelector((state) => state.notifications);
  const { visibility } = panel;

  const { subscribeOnClick } = useContext(NotificationClientContext);

  const { makeRequest: tryDestroy } = useRequest(destroyNotification);
  const { makeRequest: tryDestroyAll } = useRequest(destroyAllNotifications);
  const { makeRequest: tryClick } = useRequest(clickNotification);

  const handleOnCloseNotificationPanel = () => {
    dispatch(closeNotificationPanel());
  };

  const handleUpdateNotificationList = () => {
    dispatch(getNotifications({ _request: findNotifications }));
  };

  const handleDismissNotification = (notificationId) => {
    tryDestroy(notificationId).then(({ isOk }) => {
      if (!isOk) return;
      dispatch(getNotifications({ _request: findNotifications }));
    });
  };

  const handleDismissAllNotifications = () => {
    tryDestroyAll().then(({ isOk }) => {
      console.log(isOk)
      if (!isOk) return;
      dispatch(getNotifications({ _request: findNotifications }));
    });
  };

  const handleClickNotification = (item) => {
    const { uri, id } = item;
    tryClick(id, { clicked: true }).then(({ isOk }) => {
      if (!isOk) return;
      dispatch(getNotifications({ _request: findNotifications }));
    });
    history.push(uri);
    handleOnCloseNotificationPanel();
  };

  useEffect(() => {
    if (!subscribeOnClick) return;
    subscribeOnClick((item) => {
      handleClickNotification(item);
    });
  }, [subscribeOnClick]);

  useEffect(() => {
    if (token === null || token === undefined) return;
    handleUpdateNotificationList();
  }, [token]);

  return (
    <NotificationPanel
      visibility={visibility}
      notifications={notifications}
      onClick={handleClickNotification}
      onClose={handleOnCloseNotificationPanel}
      onDismiss={handleDismissNotification}
      onDismissAll={handleDismissAllNotifications}
    />
  );
}

export default memo(RightSideLayout1);
